<template>
  <div class="row">
    <div class="form-field form-field--stretch form-field--style-1 form-field--no-asterisk col">
      <div class="input-with-icon">
        <input
            id="location"
            v-model="dataFiltersLocation"
            class="form-control"
            type="text"
            name="location"
            autocomplete="off"
            tabindex="1"
            data-select-typeahead=""
            :placeholder="$t('messages_nl.search-form.location')"
        >
        <i class="fas fa-search"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'adivare-filter-search',
  data() {
    return {
      dataFiltersLocation: this.$store.state.filters.location.location,
    }
  },
}
</script>
